import React from 'react';

const NoResults = () => {
  return <div data-testid='overview-no-results'>NO DATA</div>;
};

export default NoResults;
